import { render, staticRenderFns } from "./release_success.vue?vue&type=template&id=2ae1c9f7&scoped=true"
import script from "./release_success.vue?vue&type=script&lang=js"
export * from "./release_success.vue?vue&type=script&lang=js"
import style0 from "./release_success.vue?vue&type=style&index=0&id=2ae1c9f7&prod&scoped=true&lang=less"
import style1 from "./release_success.vue?vue&type=style&index=1&id=2ae1c9f7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae1c9f7",
  null
  
)

export default component.exports